import React from 'react'
import AddMemberComponent from '../../components/member/AddMemberComponent'

const AddMemberPage = () => {
  return (
    <>

    <AddMemberComponent />
    </>
  )
}

export default AddMemberPage